import type { Decorator } from 'final-form';
import createDecorator from 'final-form-calculate';
import { useMemo } from 'react';

import type { FormData } from '../types';

import { useNumberFromIntl } from './useNumberFromIntl';

const useParseStakesDecorator = () => {
  const getNumberFromIntl = useNumberFromIntl();
  const parseStakes = useMemo(
    () =>
      createDecorator({
        field: /\.stakePerLine$/,
        updates: (value, name) => ({
          [`${name}Parsed`]: getNumberFromIntl(value)
        })
      }) as Decorator<FormData>,
    [getNumberFromIntl]
  );

  return parseStakes;
};

export default useParseStakesDecorator;
